// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__25vqn","list":"BalanceDue_list__2RUjY","listRow":"BalanceDue_listRow__29Cuk","total":"BalanceDue_total__wzgWs"};